import { useRef, useCallback } from "react"
export function useCurrent<T>(init: () => T): [T, () => T] {
  let ref = useRef<T | undefined>(undefined)
  if (ref.current === undefined) ref.current = init()
  let get = useCallback(() => ref.current!, [])
  return [ref.current, get]
}
